import React from "react";
/**
 * This component is used to display the required
 * privacy statement which can be found in a link in the
 * about tab.
 */
class Privacy extends React.Component {
  render() {
    return (
      <div style={{ width: '100%', height: '100vh' }}>
        <iframe
          src="https://appgenesisllc.com/privacy/"
          style={{ width: '100%', height: '100%', border: 'none' }}
          title="Privacy Policy"
        />
      </div>
    );
  }
}

export default Privacy;
